import ApiService from '@/app/common/service/ApiService';
import i18n from '@/config/i18n';
import ILanguage from '@/app/common/model/ILanguage';
import ITranslation from '@/app/common/model/ITranslation';
import ICountry from '@/app/common/model/ICountry';

export default class LanguageService {
  public static async getPublicTranslations(
    shortcut: string,
  ): Promise<ITranslation> {
    try {
      const response = await ApiService.get(`/translation/${shortcut}/public`);
      i18n.setLocaleMessage('pl', response.translations);
      return response;
    } catch (e) {
      throw e;
    }
  }

  public static async getLanguageList(): Promise<ILanguage[]> {
    const response = await ApiService.get('/language');
    return response.languageDTOList;
  }

  static async getCountryList(): Promise<ICountry[]> {
    const response = await ApiService.get('/form/country/');
    return response.countryDTOList;
  }
}
